export default __webpack_public_path__ + "EUt_userApprovals.html";